import { useState } from 'react';

const navLinks = [
  { label: '下载入口', href: '#download' },
  { label: '最新版本', href: '#version' },
  { label: '安装步骤', href: '#steps' },
  { label: '热门查询', href: '#hot' },
  { label: '图文攻略', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-200">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="h-16 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-leaf-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">蘑菇视频</span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-400 mt-0.5">MUSHROOM VIDEO</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#download"
              className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-2-line"></i>
              获取安卓版
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="max-w-[1240px] mx-auto px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              获取安卓版
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}